import React from "react";
import { DeviceCardsIcons } from "@utils/defaultImages";

const FourCardsView = ({
  data = [],
  //   columns = 3,
  gap = "gap-2",
  rounded = "rounded-[16px]",
  shadow = "7px 7px 9.5px 0px #0000000D",
  showIcon = true,
  fontFamily = "font-[Lato]",
  labelKey = "label",
  valueKey = "value",
  unitKey = "unit",
  iconKey = "icon",
  colorKey = "tabColor",
  t,
}) => {
  return (
    <div className="bg-[#E6F8FF] p-4 rounded-[17px]">
      <h2 className="text-[16px] font-[Lato] text-[#444444] mb-2 flex items-center gap-2">
        <img src={DeviceCardsIcons} alt="image" className="min-h-5 min-w-5" />
        {t("Health metrics overview")}
      </h2>
      <div className={`grid grid-cols-2 md:grid-cols-4 ${gap} ${fontFamily}`}>
        {data.map((item, index) => {
          const label = item[labelKey];
          const value = item[valueKey];
          const unit = item[unitKey];
          const icon = item[iconKey];
          const tabColor = item[colorKey];

          return (
            <div
              key={index}
              className={`py-5 px-3 ${rounded} bg-white border border-[#E6E6E6] grid md:grid-cols-2 lg:grid-cols-1 items-center gap-2 justify-center`}
              style={{
                boxShadow: shadow,
              }}
            >
              {showIcon && (
                <div className="w-full flex justify-center">
                  <div
                    className="rounded-full w-[57px] h-[57px] flex items-center justify-center"
                    style={{ backgroundColor: tabColor }}
                  >
                    {icon}
                  </div>
                </div>
              )}

              <div>
                <p className="text-[10px] md:text-[12px] font-[500] text-[#6C6A6ACC] text-center md:text-start lg:text-center">
                  {label}
                </p>
                <p className="text-[10px] md:text-[16px] font-[500] text-[#6C6A6A] text-center md:text-start lg:text-center">
                  {!value
                    ? `0 ${unit || ""}`
                    : value
                        .toString()
                        .trim()
                        .toLowerCase()
                        .endsWith(unit?.toLowerCase() || "")
                    ? value
                    : `${value} ${unit || ""}`}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FourCardsView;
